import {Avatar, Box, Chip} from "@mui/material"
import React, {useCallback} from "react"
import Icon from "./BadgeIcons/Icon"

export const widgetBadgePrototype = [
    {
        key: "variant",
        type: "SELECT",
        label: "Variante",
        size: 6,
        options: [
            {
                value: "success",
                label: "Success",
            },
            {
                value: "error",
                label: "Error",
            },
            {
                value: "warning",
                label: "Warning",
            },
            {
                value: "info",
                label: "Info",
            },
            {
                value: "neutral",
                label: "Neutral",
            },
        ],
    },
    {
        key: "showIcon",
        type: "YESNO",
        label: "Icon Anzeigen",
        size: 3,
    },
    {
        key: "backgroundColor",
        type: "COLOR",
        label: "Hintergrundfarbe",
        size: 3,
    },
    {
        key: "color",
        type: "COLOR",
        label: "Schriftfarbe",
        size: 3,
    },
]

const iconMap = {
    success: (
        <Icon
            color="#fff"
            iconName="Check"
            size="inherit"
        />
    ),
    error: (
        <Icon
            color="#fff"
            iconName="Cross"
            size="inherit"
        />
    ),
    warning: (
        <Icon
            size="inherit"
            color="#000"
            iconName="Attention"
        />
    ),
    info: (
        <Icon
            size="inherit"
            color="#fff"
            iconName="Info"
        />
    ),
    neutral: (
        <Icon
            size="inherit"
            color="#fff"
            iconName="Info"
        />
    ),
}

const avatarPlaceholder = " "

const BadgeWidget = ({widget, value}) => {
    const label = value ?? widget.text
    const variant = widget.variant
    const hasIcon = widget.showIcon

    const getAvatarByProps = useCallback(() => {
        return label ? (
            hasIcon ? (
                <Avatar>{iconMap[variant]}</Avatar>
            ) : undefined
        ) : (
            <Avatar>{avatarPlaceholder}</Avatar>
        )
    }, [label, hasIcon, variant])

    return (
        <Box
            width="100%"
            display="flex"
            alignItems="center"
            justifyContent="center">
            <Chip
                avatar={getAvatarByProps()}
                {...(label ? {label} : {})}
                color={variant}
                sx={{
                    ...(widget.backgroundColor ? {backgroundColor: widget.backgroundColor} : {}),
                    ...(widget.color ? {color: widget.color, "& .MuiChip-label": {color: widget.color}} : {}),
                }}
            />
        </Box>
    )
}

export default BadgeWidget
